import React from 'react';
import PropTypes from 'prop-types';
import LabeledField from './labeled-field';

import style from './order-summary.module.less';
import FormattedCurrency from '../../../../components/formatted-currency/container';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';
import { useEntitiesSalesOrder } from '../../../../hooks/entities/selectors/sales-orders';
import { MessageDescriptorPropType } from '../../../../prop-types/intl';
import { emptyArray } from 'ui-components/default-props/empty';
import { DiscountField } from './discounts/discount-field';
import { calculateTotalAmount } from '../../../../fulfillment-plans/amount-summary/helper';
import { CountryConfigNames } from '../../../../contexts/country-config-context/country-config-enums';
import { useCountryConfig } from '../../../../hooks/use-country-config';

import messages from './messages';
import { FormattedMessage } from 'react-intl';
import { FlexColumn } from 'ui-components/components/flex';

const LabeledCurrencyField = ({ label, currency }) => {
  return (
    <LabeledField label={<FormattedMessage {...label} />}>
      <div className={style['field-content']}>
        <FormattedCurrency currencyCode={currency.code} value={currency.value} />
      </div>
    </LabeledField>
  );
};

LabeledCurrencyField.propTypes = {
  label: MessageDescriptorPropType.isRequired,
  currency: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
};

const AmountSummary = () => {
  const salesOrderId = useSalesOrderIdContext();
  const salesOrder = useEntitiesSalesOrder(salesOrderId) ?? {};
  const [isTaxesIncludedInOrdersTotal] = useCountryConfig(CountryConfigNames.TaxesIncludedInOrdersTotal);

  const { amountSummary, discounts = emptyArray } = salesOrder;

  if (amountSummary == null) {
    return null;
  }

  const { productTotal, shippingPaid, taxPaid, totalPaid, orderTotal } = amountSummary;
  const orderTotalValue = calculateTotalAmount(productTotal.value, shippingPaid.value, taxPaid.value, isTaxesIncludedInOrdersTotal);

  return (
    <FlexColumn className={style['split-flex-row']}>
      <LabeledCurrencyField currency={productTotal} label={messages.productTotalLabel} />
      <LabeledCurrencyField currency={shippingPaid} label={messages.shippingPaidLabel} />
      <LabeledCurrencyField currency={taxPaid} label={messages.taxPaidLabel} />
      <LabeledCurrencyField currency={{ ...orderTotal, value: orderTotalValue }} label={messages.orderTotalLabel} />
      <DiscountField discounts={discounts} />
      <LabeledCurrencyField currency={totalPaid} label={messages.totalPaidLabel} />
    </FlexColumn>
  );
};

export default AmountSummary;
